import { CHAIN_ID } from '@derivation-tech/context';

export const CHAIN_HTTP_RPC_URLS: { [chainId: number]: string[] } = {
  [CHAIN_ID.BLASTSEPOLIA]: [`https://sepolia.blast.io`],
  [CHAIN_ID.BASE]: [
    `https://mainnet-preconf.base.org/iVCRlQ4dHSYzXgOMMBfoR92yxGCndKUnJ0tF0dwAyzDN73xrJFYrQiNAPB9FRcVb`,
    // `https://mainnet.base.org`,
    // `https://rpc.ankr.com/base`,
    // 'https://base-mainnet.public.blastapi.io',
    // `https://base-pokt.nodies.app`,
    // `https://base.meowrpc.com`,
    // `https://base.rpc.subquery.network/public`,
  ],
  [CHAIN_ID.BLAST]: [
    `https://rpc.blast.io`,
    // 'https://blast-public.nodies.app',
    // 'https://blast.drpc.org',
    // 'https://blast-rpc.publicnode.com',
  ],
  [CHAIN_ID.GELATO]: [`https://rpc.mysterious-present-place.t.raas.gelato.cloud/2ff2e1ea1a68484785779c5a072bed95`],
  [CHAIN_ID.ABC]: [`https://rpc.synfutures-abc-testnet.raas.gelato.cloud/2ff2e1ea1a68484785779c5a072bed95`],
  [CHAIN_ID.MONADTESTNET]: [`https://testnet-rpc.monad.xyz`],
};
